// Unpublished Work © 2026 Deere & Company.

// Stable id MUI X assigns to the root aggregation (grand-total) footer row. Mirrors
// GRID_AGGREGATION_ROOT_FOOTER_ROW_ID from @mui/x-data-grid-premium, duplicated here so
// consumers stay decoupled from a direct MUI import. In MUI v8 this footer is a pinned row
// (rowNode.type === 'pinnedRow'), so a `type === 'footer'` check alone does not match it;
// per-group footers (row grouping) are the ones tagged `type === 'footer'`.
const GRID_AGGREGATION_ROOT_FOOTER_ROW_ID = 'auto-generated-group-footer-root';

export function isAggregationFooterRow(params) {
    return params?.rowNode?.type === 'footer' || params?.id === GRID_AGGREGATION_ROOT_FOOTER_ROW_ID;
}
